import { orderBy as _orderBy } from 'lodash';

import { LocalCountries, LocalCountry } from '.';
import { SelectFieldModelOption } from '..';

import { formatMessage } from 'src/api';
import MESSAGES from './locals-countries.messages';


export const localCountriesData = (): LocalCountries => ({
  // icIC: {
  //   code: 'ic-IC',
  //   name: formatMessage({...MESSAGES.localsIC})
  // },
  meME: {
    code: 'me-ME',
    name: formatMessage({...MESSAGES.localsME})
  },
  mfMF: {
    code: 'mf-MF',
    name: formatMessage({...MESSAGES.localsMF})
  },
  rsRS: {
    code: 'rs-RS',
    name: formatMessage({...MESSAGES.localsRS})
  },
  adAD: {
    code: 'ad-AD',
    name: formatMessage({...MESSAGES.localsAD})
  },
  aeAE: {
    code: 'ae-AE',
    name: formatMessage({...MESSAGES.localsAE})
  },
  afAF: {
    code: 'af-AF',
    name: formatMessage({...MESSAGES.localsAF})
  },
  agAG: {
    code: 'ag-AG',
    name: formatMessage({...MESSAGES.localsAG})
  },
  aiAI: {
    code: 'ai-AI',
    name: formatMessage({...MESSAGES.localsAI})
  },
  alAL: {
    code: 'al-AL',
    name: formatMessage({...MESSAGES.localsAL})
  },
  amAM: {
    code: 'am-AM',
    name: formatMessage({...MESSAGES.localsAM})
  },
  anAN: {
    code: 'an-AN',
    name: formatMessage({...MESSAGES.localsAN})
  },
  aoAO: {
    code: 'ao-AO',
    name: formatMessage({...MESSAGES.localsAO})
  },
  aqAQ: {
    code: 'aq-AQ',
    name: formatMessage({...MESSAGES.localsAQ})
  },
  arAR: {
    code: 'ar-AR',
    name: formatMessage({...MESSAGES.localsAR})
  },
  asAS: {
    code: 'as-AS',
    name: formatMessage({...MESSAGES.localsAS})
  },
  atAT: {
    code: 'at-AT',
    name: formatMessage({...MESSAGES.localsAT})
  },
  auAU: {
    code: 'au-AU',
    name: formatMessage({...MESSAGES.localsAU})
  },
  awAW: {
    code: 'aw-AW',
    name: formatMessage({...MESSAGES.localsAW})
  },
  azAZ: {
    code: 'az-AZ',
    name: formatMessage({...MESSAGES.localsAZ})
  },
  baBA: {
    code: 'ba-BA',
    name: formatMessage({...MESSAGES.localsBA})
  },
  bbBB: {
    code: 'bb-BB',
    name: formatMessage({...MESSAGES.localsBB})
  },
  bdBD: {
    code: 'bd-BD',
    name: formatMessage({...MESSAGES.localsBD})
  },
  beBE: {
    code: 'be-BE',
    name: formatMessage({...MESSAGES.localsBE})
  },
  bfBF: {
    code: 'bf-BF',
    name: formatMessage({...MESSAGES.localsBF})
  },
  bgBG: {
    code: 'bg-BG',
    name: formatMessage({...MESSAGES.localsBG})
  },
  bhBH: {
    code: 'bh-BH',
    name: formatMessage({...MESSAGES.localsBH})
  },
  biBI: {
    code: 'bi-BI',
    name: formatMessage({...MESSAGES.localsBI})
  },
  bjBJ: {
    code: 'bj-BJ',
    name: formatMessage({...MESSAGES.localsBJ})
  },
  bmBM: {
    code: 'bm-BM',
    name: formatMessage({...MESSAGES.localsBM})
  },
  bnBN: {
    code: 'bn-BN',
    name: formatMessage({...MESSAGES.localsBN})
  },
  boBO: {
    code: 'bo-BO',
    name: formatMessage({...MESSAGES.localsBO})
  },
  brBR: {
    code: 'br-BR',
    name: formatMessage({...MESSAGES.localsBR})
  },
  bsBS: {
    code: 'bs-BS',
    name: formatMessage({...MESSAGES.localsBS})
  },
  btBT: {
    code: 'bt-BT',
    name: formatMessage({...MESSAGES.localsBT})
  },
  bvBV: {
    code: 'bv-BV',
    name: formatMessage({...MESSAGES.localsBV})
  },
  bwBW: {
    code: 'bw-BW',
    name: formatMessage({...MESSAGES.localsBW})
  },
  byBY: {
    code: 'by-BY',
    name: formatMessage({...MESSAGES.localsBY})
  },
  bzBZ: {
    code: 'bz-BZ',
    name: formatMessage({...MESSAGES.localsBZ})
  },
  caCA: {
    code: 'ca-CA',
    name: formatMessage({...MESSAGES.localsCA})
  },
  ccCC: {
    code: 'cc-CC',
    name: formatMessage({...MESSAGES.localsCC})
  },
  cdCD: {
    code: 'cd-CD',
    name: formatMessage({...MESSAGES.localsCD})
  },
  cfCF: {
    code: 'cf-CF',
    name: formatMessage({...MESSAGES.localsCF})
  },
  cgCG: {
    code: 'cg-CG',
    name: formatMessage({...MESSAGES.localsCG})
  },
  chCH: {
    code: 'ch-CH',
    name: formatMessage({...MESSAGES.localsCH})
  },
  ciCI: {
    code: 'ci-CI',
    name: formatMessage({...MESSAGES.localsCI})
  },
  ckCK: {
    code: 'ck-CK',
    name: formatMessage({...MESSAGES.localsCK})
  },
  clCL: {
    code: 'cl-CL',
    name: formatMessage({...MESSAGES.localsCL})
  },
  cmCM: {
    code: 'cm-CM',
    name: formatMessage({...MESSAGES.localsCM})
  },
  cnCN: {
    code: 'cn-CN',
    name: formatMessage({...MESSAGES.localsCN})
  },
  coCO: {
    code: 'co-CO',
    name: formatMessage({...MESSAGES.localsCO})
  },
  crCR: {
    code: 'cr-CR',
    name: formatMessage({...MESSAGES.localsCR})
  },
  cuCU: {
    code: 'cu-CU',
    name: formatMessage({...MESSAGES.localsCU})
  },
  cvCV: {
    code: 'cv-CV',
    name: formatMessage({...MESSAGES.localsCV})
  },
  cxCX: {
    code: 'cx-CX',
    name: formatMessage({...MESSAGES.localsCX})
  },
  cyCY: {
    code: 'cy-CY',
    name: formatMessage({...MESSAGES.localsCY})
  },
  czCZ: {
    code: 'cz-CZ',
    name: formatMessage({...MESSAGES.localsCZ})
  },
  deDE: {
    code: 'de-DE',
    name: formatMessage({...MESSAGES.localsDE})
  },
  djDJ: {
    code: 'dj-DJ',
    name: formatMessage({...MESSAGES.localsDJ})
  },
  dkDK: {
    code: 'dk-DK',
    name: formatMessage({...MESSAGES.localsDK})
  },
  dmDM: {
    code: 'dm-DM',
    name: formatMessage({...MESSAGES.localsDM})
  },
  doDO: {
    code: 'do-DO',
    name: formatMessage({...MESSAGES.localsDO})
  },
  dzDZ: {
    code: 'dz-DZ',
    name: formatMessage({...MESSAGES.localsDZ})
  },
  ecEC: {
    code: 'ec-EC',
    name: formatMessage({...MESSAGES.localsEC})
  },
  eeEE: {
    code: 'ee-EE',
    name: formatMessage({...MESSAGES.localsEE})
  },
  egEG: {
    code: 'eg-EG',
    name: formatMessage({...MESSAGES.localsEG})
  },
  ehEH: {
    code: 'eh-EH',
    name: formatMessage({...MESSAGES.localsEH})
  },
  erER: {
    code: 'er-ER',
    name: formatMessage({...MESSAGES.localsER})
  },
  esES: {
    code: 'es-ES',
    name: formatMessage({...MESSAGES.localsES})
  },
  etET: {
    code: 'et-ET',
    name: formatMessage({...MESSAGES.localsET})
  },
  fiFI: {
    code: 'fi-FI',
    name: formatMessage({...MESSAGES.localsFI})
  },
  fjFJ: {
    code: 'fj-FJ',
    name: formatMessage({...MESSAGES.localsFJ})
  },
  fkFK: {
    code: 'fk-FK',
    name: formatMessage({...MESSAGES.localsFK})
  },
  fmFM: {
    code: 'fm-FM',
    name: formatMessage({...MESSAGES.localsFM})
  },
  foFO: {
    code: 'fo-FO',
    name: formatMessage({...MESSAGES.localsFO})
  },
  frFR: {
    code: 'fr-FR',
    name: formatMessage({...MESSAGES.localsFR})
  },
  gaGA: {
    code: 'ga-GA',
    name: formatMessage({...MESSAGES.localsGA})
  },
  gbGB: {
    code: 'gb-GB',
    name: formatMessage({...MESSAGES.localsGB})
  },
  gdGD: {
    code: 'gd-GD',
    name: formatMessage({...MESSAGES.localsGD})
  },
  geGE: {
    code: 'ge-GE',
    name: formatMessage({...MESSAGES.localsGE})
  },
  gfGF: {
    code: 'gf-GF',
    name: formatMessage({...MESSAGES.localsGF})
  },
  ghGH: {
    code: 'gh-GH',
    name: formatMessage({...MESSAGES.localsGH})
  },
  giGI: {
    code: 'gi-GI',
    name: formatMessage({...MESSAGES.localsGI})
  },
  glGL: {
    code: 'gl-GL',
    name: formatMessage({...MESSAGES.localsGL})
  },
  gmGM: {
    code: 'gm-GM',
    name: formatMessage({...MESSAGES.localsGM})
  },
  gnGN: {
    code: 'gn-GN',
    name: formatMessage({...MESSAGES.localsGN})
  },
  gpGP: {
    code: 'gp-GP',
    name: formatMessage({...MESSAGES.localsGP})
  },
  gqGQ: {
    code: 'gq-GQ',
    name: formatMessage({...MESSAGES.localsGQ})
  },
  grGR: {
    code: 'gr-GR',
    name: formatMessage({...MESSAGES.localsGR})
  },
  gsGS: {
    code: 'gs-GS',
    name: formatMessage({...MESSAGES.localsGS})
  },
  gtGT: {
    code: 'gt-GT',
    name: formatMessage({...MESSAGES.localsGT})
  },
  guGU: {
    code: 'gu-GU',
    name: formatMessage({...MESSAGES.localsGU})
  },
  gwGW: {
    code: 'gw-GW',
    name: formatMessage({...MESSAGES.localsGW})
  },
  gyGY: {
    code: 'gy-GY',
    name: formatMessage({...MESSAGES.localsGY})
  },
  hkHK: {
    code: 'hk-HK',
    name: formatMessage({...MESSAGES.localsHK})
  },
  hmHM: {
    code: 'hm-HM',
    name: formatMessage({...MESSAGES.localsHM})
  },
  hnHN: {
    code: 'hn-HN',
    name: formatMessage({...MESSAGES.localsHN})
  },
  hrHR: {
    code: 'hr-HR',
    name: formatMessage({...MESSAGES.localsHR})
  },
  htHT: {
    code: 'ht-HT',
    name: formatMessage({...MESSAGES.localsHT})
  },
  huHU: {
    code: 'hu-HU',
    name: formatMessage({...MESSAGES.localsHU})
  },
  idID: {
    code: 'id-ID',
    name: formatMessage({...MESSAGES.localsID})
  },
  ieIE: {
    code: 'ie-IE',
    name: formatMessage({...MESSAGES.localsIE})
  },
  ilIL: {
    code: 'il-IL',
    name: formatMessage({...MESSAGES.localsIL})
  },
  inIN: {
    code: 'in-IN',
    name: formatMessage({...MESSAGES.localsIN})
  },
  ioIO: {
    code: 'io-IO',
    name: formatMessage({...MESSAGES.localsIO})
  },
  iqIQ: {
    code: 'iq-IQ',
    name: formatMessage({...MESSAGES.localsIQ})
  },
  irIR: {
    code: 'ir-IR',
    name: formatMessage({...MESSAGES.localsIR})
  },
  isIS: {
    code: 'is-IS',
    name: formatMessage({...MESSAGES.localsIS})
  },
  itIT: {
    code: 'it-IT',
    name: formatMessage({...MESSAGES.localsIT})
  },
  jmJM: {
    code: 'jm-JM',
    name: formatMessage({...MESSAGES.localsJM})
  },
  joJO: {
    code: 'jo-JO',
    name: formatMessage({...MESSAGES.localsJO})
  },
  jpJP: {
    code: 'jp-JP',
    name: formatMessage({...MESSAGES.localsJP})
  },
  keKE: {
    code: 'ke-KE',
    name: formatMessage({...MESSAGES.localsKE})
  },
  kgKG: {
    code: 'kg-KG',
    name: formatMessage({...MESSAGES.localsKG})
  },
  khKH: {
    code: 'kh-KH',
    name: formatMessage({...MESSAGES.localsKH})
  },
  kiKI: {
    code: 'ki-KI',
    name: formatMessage({...MESSAGES.localsKI})
  },
  kmKM: {
    code: 'km-KM',
    name: formatMessage({...MESSAGES.localsKM})
  },
  knKN: {
    code: 'kn-KN',
    name: formatMessage({...MESSAGES.localsKN})
  },
  kpKP: {
    code: 'kp-KP',
    name: formatMessage({...MESSAGES.localsKP})
  },
  krKR: {
    code: 'kr-KR',
    name: formatMessage({...MESSAGES.localsKR})
  },
  kwKW: {
    code: 'kw-KW',
    name: formatMessage({...MESSAGES.localsKW})
  },
  kyKY: {
    code: 'ky-KY',
    name: formatMessage({...MESSAGES.localsKY})
  },
  kzKZ: {
    code: 'kz-KZ',
    name: formatMessage({...MESSAGES.localsKZ})
  },
  laLA: {
    code: 'la-LA',
    name: formatMessage({...MESSAGES.localsLA})
  },
  lbLB: {
    code: 'lb-LB',
    name: formatMessage({...MESSAGES.localsLB})
  },
  lcLC: {
    code: 'lc-LC',
    name: formatMessage({...MESSAGES.localsLC})
  },
  liLI: {
    code: 'li-LI',
    name: formatMessage({...MESSAGES.localsLI})
  },
  lkLK: {
    code: 'lk-LK',
    name: formatMessage({...MESSAGES.localsLK})
  },
  lrLR: {
    code: 'lr-LR',
    name: formatMessage({...MESSAGES.localsLR})
  },
  lsLS: {
    code: 'ls-LS',
    name: formatMessage({...MESSAGES.localsLS})
  },
  ltLT: {
    code: 'lt-LT',
    name: formatMessage({...MESSAGES.localsLT})
  },
  luLU: {
    code: 'lu-LU',
    name: formatMessage({...MESSAGES.localsLU})
  },
  lvLV: {
    code: 'lv-LV',
    name: formatMessage({...MESSAGES.localsLV})
  },
  lyLY: {
    code: 'ly-LY',
    name: formatMessage({...MESSAGES.localsLY})
  },
  maMA: {
    code: 'ma-MA',
    name: formatMessage({...MESSAGES.localsMA})
  },
  mcMC: {
    code: 'mc-MC',
    name: formatMessage({...MESSAGES.localsMC})
  },
  mdMD: {
    code: 'md-MD',
    name: formatMessage({...MESSAGES.localsMD})
  },
  mgMG: {
    code: 'mg-MG',
    name: formatMessage({...MESSAGES.localsMG})
  },
  mhMH: {
    code: 'mh-MH',
    name: formatMessage({...MESSAGES.localsMH})
  },
  mkMK: {
    code: 'mk-MK',
    name: formatMessage({...MESSAGES.localsMK})
  },
  mlML: {
    code: 'ml-ML',
    name: formatMessage({...MESSAGES.localsML})
  },
  mmMM: {
    code: 'mm-MM',
    name: formatMessage({...MESSAGES.localsMM})
  },
  mnMN: {
    code: 'mn-MN',
    name: formatMessage({...MESSAGES.localsMN})
  },
  moMO: {
    code: 'mo-MO',
    name: formatMessage({...MESSAGES.localsMO})
  },
  mpMP: {
    code: 'mp-MP',
    name: formatMessage({...MESSAGES.localsMP})
  },
  mqMQ: {
    code: 'mq-MQ',
    name: formatMessage({...MESSAGES.localsMQ})
  },
  mrMR: {
    code: 'mr-MR',
    name: formatMessage({...MESSAGES.localsMR})
  },
  msMS: {
    code: 'ms-MS',
    name: formatMessage({...MESSAGES.localsMS})
  },
  mtMT: {
    code: 'mt-MT',
    name: formatMessage({...MESSAGES.localsMT})
  },
  muMU: {
    code: 'mu-MU',
    name: formatMessage({...MESSAGES.localsMU})
  },
  mvMV: {
    code: 'mv-MV',
    name: formatMessage({...MESSAGES.localsMV})
  },
  mwMW: {
    code: 'mw-MW',
    name: formatMessage({...MESSAGES.localsMW})
  },
  mxMX: {
    code: 'mx-MX',
    name: formatMessage({...MESSAGES.localsMX})
  },
  myMY: {
    code: 'my-MY',
    name: formatMessage({...MESSAGES.localsMY})
  },
  mzMZ: {
    code: 'mz-MZ',
    name: formatMessage({...MESSAGES.localsMZ})
  },
  naNA: {
    code: 'na-NA',
    name: formatMessage({...MESSAGES.localsNA})
  },
  ncNC: {
    code: 'nc-NC',
    name: formatMessage({...MESSAGES.localsNC})
  },
  neNE: {
    code: 'ne-NE',
    name: formatMessage({...MESSAGES.localsNE})
  },
  nfNF: {
    code: 'nf-NF',
    name: formatMessage({...MESSAGES.localsNF})
  },
  ngNG: {
    code: 'ng-NG',
    name: formatMessage({...MESSAGES.localsNG})
  },
  niNI: {
    code: 'ni-NI',
    name: formatMessage({...MESSAGES.localsNI})
  },
  nlNL: {
    code: 'nl-NL',
    name: formatMessage({...MESSAGES.localsNL})
  },
  noNO: {
    code: 'no-NO',
    name: formatMessage({...MESSAGES.localsNO})
  },
  npNP: {
    code: 'np-NP',
    name: formatMessage({...MESSAGES.localsNP})
  },
  nrNR: {
    code: 'nr-NR',
    name: formatMessage({...MESSAGES.localsNR})
  },
  nuNU: {
    code: 'nu-NU',
    name: formatMessage({...MESSAGES.localsNU})
  },
  nzNZ: {
    code: 'nz-NZ',
    name: formatMessage({...MESSAGES.localsNZ})
  },
  omOM: {
    code: 'om-OM',
    name: formatMessage({...MESSAGES.localsOM})
  },
  paPA: {
    code: 'pa-PA',
    name: formatMessage({...MESSAGES.localsPA})
  },
  pePE: {
    code: 'pe-PE',
    name: formatMessage({...MESSAGES.localsPE})
  },
  pfPF: {
    code: 'pf-PF',
    name: formatMessage({...MESSAGES.localsPF})
  },
  pgPG: {
    code: 'pg-PG',
    name: formatMessage({...MESSAGES.localsPG})
  },
  phPH: {
    code: 'ph-PH',
    name: formatMessage({...MESSAGES.localsPH})
  },
  pkPK: {
    code: 'pk-PK',
    name: formatMessage({...MESSAGES.localsPK})
  },
  plPL: {
    code: 'pl-PL',
    name: formatMessage({...MESSAGES.localsPL})
  },
  pmPM: {
    code: 'pm-PM',
    name: formatMessage({...MESSAGES.localsPM})
  },
  pnPN: {
    code: 'pn-PN',
    name: formatMessage({...MESSAGES.localsPN})
  },
  prPR: {
    code: 'pr-PR',
    name: formatMessage({...MESSAGES.localsPR})
  },
  psPS: {
    code: 'ps-PS',
    name: formatMessage({...MESSAGES.localsPS})
  },
  ptPT: {
    code: 'pt-PT',
    name: formatMessage({...MESSAGES.localsPT})
  },
  pwPW: {
    code: 'pw-PW',
    name: formatMessage({...MESSAGES.localsPW})
  },
  pyPY: {
    code: 'py-PY',
    name: formatMessage({...MESSAGES.localsPY})
  },
  qaQA: {
    code: 'qa-QA',
    name: formatMessage({...MESSAGES.localsQA})
  },
  reRE: {
    code: 're-RE',
    name: formatMessage({...MESSAGES.localsRE})
  },
  roRO: {
    code: 'ro-RO',
    name: formatMessage({...MESSAGES.localsRO})
  },
  ruRU: {
    code: 'ru-RU',
    name: formatMessage({...MESSAGES.localsRU})
  },
  rwRW: {
    code: 'rw-RW',
    name: formatMessage({...MESSAGES.localsRW})
  },
  saSA: {
    code: 'sa-SA',
    name: formatMessage({...MESSAGES.localsSA})
  },
  sbSB: {
    code: 'sb-SB',
    name: formatMessage({...MESSAGES.localsSB})
  },
  scSC: {
    code: 'sc-SC',
    name: formatMessage({...MESSAGES.localsSC})
  },
  sdSD: {
    code: 'sd-SD',
    name: formatMessage({...MESSAGES.localsSD})
  },
  seSE: {
    code: 'se-SE',
    name: formatMessage({...MESSAGES.localsSE})
  },
  sgSG: {
    code: 'sg-SG',
    name: formatMessage({...MESSAGES.localsSG})
  },
  shSH: {
    code: 'sh-SH',
    name: formatMessage({...MESSAGES.localsSH})
  },
  siSI: {
    code: 'si-SI',
    name: formatMessage({...MESSAGES.localsSI})
  },
  sjSJ: {
    code: 'sj-SJ',
    name: formatMessage({...MESSAGES.localsSJ})
  },
  skSK: {
    code: 'sk-SK',
    name: formatMessage({...MESSAGES.localsSK})
  },
  slSL: {
    code: 'sl-SL',
    name: formatMessage({...MESSAGES.localsSL})
  },
  smSM: {
    code: 'sm-SM',
    name: formatMessage({...MESSAGES.localsSM})
  },
  snSN: {
    code: 'sn-SN',
    name: formatMessage({...MESSAGES.localsSN})
  },
  soSO: {
    code: 'so-SO',
    name: formatMessage({...MESSAGES.localsSO})
  },
  srSR: {
    code: 'sr-SR',
    name: formatMessage({...MESSAGES.localsSR})
  },
  stST: {
    code: 'st-ST',
    name: formatMessage({...MESSAGES.localsST})
  },
  svSV: {
    code: 'sv-SV',
    name: formatMessage({...MESSAGES.localsSV})
  },
  sySY: {
    code: 'sy-SY',
    name: formatMessage({...MESSAGES.localsSY})
  },
  szSZ: {
    code: 'sz-SZ',
    name: formatMessage({...MESSAGES.localsSZ})
  },
  tcTC: {
    code: 'tc-TC',
    name: formatMessage({...MESSAGES.localsTC})
  },
  tdTD: {
    code: 'td-TD',
    name: formatMessage({...MESSAGES.localsTD})
  },
  tfTF: {
    code: 'tf-TF',
    name: formatMessage({...MESSAGES.localsTF})
  },
  tgTG: {
    code: 'tg-TG',
    name: formatMessage({...MESSAGES.localsTG})
  },
  thTH: {
    code: 'th-TH',
    name: formatMessage({...MESSAGES.localsTH})
  },
  tjTJ: {
    code: 'tj-TJ',
    name: formatMessage({...MESSAGES.localsTJ})
  },
  tkTK: {
    code: 'tk-TK',
    name: formatMessage({...MESSAGES.localsTK})
  },
  tlTL: {
    code: 'tl-TL',
    name: formatMessage({...MESSAGES.localsTL})
  },
  tmTM: {
    code: 'tm-TM',
    name: formatMessage({...MESSAGES.localsTM})
  },
  tnTN: {
    code: 'tn-TN',
    name: formatMessage({...MESSAGES.localsTN})
  },
  toTO: {
    code: 'to-TO',
    name: formatMessage({...MESSAGES.localsTO})
  },
  trTR: {
    code: 'tr-TR',
    name: formatMessage({...MESSAGES.localsTR})
  },
  ttTT: {
    code: 'tt-TT',
    name: formatMessage({...MESSAGES.localsTT})
  },
  tvTV: {
    code: 'tv-TV',
    name: formatMessage({...MESSAGES.localsTV})
  },
  twTW: {
    code: 'tw-TW',
    name: formatMessage({...MESSAGES.localsTW})
  },
  tzTZ: {
    code: 'tz-TZ',
    name: formatMessage({...MESSAGES.localsTZ})
  },
  uaUA: {
    code: 'ua-UA',
    name: formatMessage({...MESSAGES.localsUA})
  },
  ugUG: {
    code: 'ug-UG',
    name: formatMessage({...MESSAGES.localsUG})
  },
  umUM: {
    code: 'um-UM',
    name: formatMessage({...MESSAGES.localsUM})
  },
  usUS: {
    code: 'us-US',
    name: formatMessage({...MESSAGES.localsUS})
  },
  uyUY: {
    code: 'uy-UY',
    name: formatMessage({...MESSAGES.localsUY})
  },
  uzUZ: {
    code: 'uz-UZ',
    name: formatMessage({...MESSAGES.localsUZ})
  },
  vaVA: {
    code: 'va-VA',
    name: formatMessage({...MESSAGES.localsVA})
  },
  vcVC: {
    code: 'vc-VC',
    name: formatMessage({...MESSAGES.localsVC})
  },
  veVE: {
    code: 've-VE',
    name: formatMessage({...MESSAGES.localsVE})
  },
  vgVG: {
    code: 'vg-VG',
    name: formatMessage({...MESSAGES.localsVG})
  },
  viVI: {
    code: 'vi-VI',
    name: formatMessage({...MESSAGES.localsVI})
  },
  vnVN: {
    code: 'vn-VN',
    name: formatMessage({...MESSAGES.localsVN})
  },
  vuVU: {
    code: 'vu-VU',
    name: formatMessage({...MESSAGES.localsVU})
  },
  wfWF: {
    code: 'wf-WF',
    name: formatMessage({...MESSAGES.localsWF})
  },
  wsWS: {
    code: 'ws-WS',
    name: formatMessage({...MESSAGES.localsWS})
  },
  yeYE: {
    code: 'ye-YE',
    name: formatMessage({...MESSAGES.localsYE})
  },
  ytYT: {
    code: 'yt-YT',
    name: formatMessage({...MESSAGES.localsYT})
  },
  zaZA: {
    code: 'za-ZA',
    name: formatMessage({...MESSAGES.localsZA})
  },
  zmZM: {
    code: 'zm-ZM',
    name: formatMessage({...MESSAGES.localsZM})
  },
  zwZW: {
    code: 'zw-ZW',
    name: formatMessage({...MESSAGES.localsZW})
  }
});

export const internalCountriesData = (): LocalCountries => ({
  ic1IC1: {
    code: 'ic1-IC1',
    name: formatMessage({...MESSAGES.localsIC1})
  },
  ic2IC2: {
    code: 'ic2-IC2',
    name: formatMessage({...MESSAGES.localsIC2})
  }
});

export const localCountriesAsArray = (): LocalCountry[] => {
  const countries = localCountriesData();
  const countriesArray: LocalCountry[] = [];
  Object.keys(countries).map(key => countriesArray.push(countries[key]));

  return countriesArray;
}

export const internalCountriesAsArray = (): LocalCountry[] => {
  const countries = internalCountriesData();
  const countriesArray: LocalCountry[] = [];
  Object.keys(countries).map(key => countriesArray.push(countries[key]));

  return countriesArray;
}

export const orderedCountriesAsArray = (isInternal: boolean = false): LocalCountry[] => {
  const localCountries = localCountriesAsArray();
  const internalCountries = isInternal ? internalCountriesAsArray() : [];
  const countries = [...localCountries, ...internalCountries];

  const orderedCountries: LocalCountry[] = _orderBy(countries, c => c.name, 'asc');

  return orderedCountries;
}

export const countriesSelectArray = (isInternal: boolean = false): SelectFieldModelOption[] => {
  const countries = orderedCountriesAsArray(isInternal);
  const selectArray = countries.map(country => ({
    label: country.name,
    value: country.code,
  }))

  return selectArray;
};

export const getCountryNameByCode = (code: string): string | undefined => {
  const country = localCountriesData()[code.replace('-', '')];
  const name = country && country.name;

  return name ? name : undefined;
};

